import { Injectable } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ToastController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class ToastService {

  constructor(
    public toastController: ToastController,
    private translate: TranslateService,
    private sanitizer : DomSanitizer 
  ) { }

  async message(message: string = '', color: string = 'light', position: 'top'|'middle'|'bottom' = 'bottom', duration?: number){
    const toast = await this.toastController.create({
      message,
      position,
      color,
      duration,
      buttons: ['OK']
    });
    await toast.present();
  }

  async error(message: string = '', color: string = 'danger'){
    const toast = await this.toastController.create({
      message: message || this.translate.instant('went_wrong'),
      position: 'bottom',
      color,
      buttons: ['OK']
    });
    await toast.present();
  }

  async success(message: string = '', color: string = 'success'){
    const toast = await this.toastController.create({
      message: message || this.translate.instant('actions.operation_executed'),
      position: 'bottom',
      color,
      buttons: ['OK']
    });
    await toast.present();
  }

  async successPrayer(message: string = '', color: string = 'success'){
    const toast = await this.toastController.create({
      message: message || this.translate.instant('actions.operation_executed'),
      duration : 6000,
      position: 'bottom',
      color,
      buttons: ['OK']
    });
    await toast.present();
  }

  async htmlMessage(message: string = '', color: string = 'light', position: 'top'|'middle'|'bottom' = 'bottom', includePrefix = true) {
    const toast = await this.toastController.create({
      message: '', 
      duration : 10000,
      position,
      color,
      buttons: ['OK'],
      cssClass: 'custom-html-toast toast-html-message'
    });

    await toast.present().then(() => {
      setTimeout(() => {
        const toastEl = document.querySelector('ion-toast.toast-html-message');
        if (toastEl) {
          const shadowRoot = (toastEl as any).shadowRoot;
          if (shadowRoot) {
            const msg = shadowRoot.querySelector('.toast-message');
            if (msg) {
              msg.innerHTML = includePrefix
                ? this.translate.instant('common.error') + ': ' + message
                : message;
            }
          }
        }
      }, 20);
    });
  }
}